import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useScheduleActionsContainerMethod } from '../../../../context/ScheduleActionsContainerContext';
import { ScheduleActionsProvider } from './ScheduleActionsProvider';
import { ScheduleActionsTabContent } from './ScheduleActionsTabContent';
import { SchedulePulseContactPatientsPanelV2 } from './ScheduleMassMessages/schedule-pulse-contact-patients-panel-v2';
import { SchedulePulseContactPatientsPanelV3 } from './ScheduleMassMessagesV3/schedule-pulse-contact-patients-panel-v3';

export const ScheduleActionsModalContainer = () => {
  const { hideTabs, closeModal } = useScheduleActionsContainerMethod();
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();
  if (hideTabs) {
    return isScheduleV3FlagEnabled ? <SchedulePulseContactPatientsPanelV3 /> : <SchedulePulseContactPatientsPanelV2 />;
  }

  return (
    <ScheduleActionsProvider closeModal={closeModal}>
      <ScheduleActionsTabContent />
    </ScheduleActionsProvider>
  );
};
